// extracted by mini-css-extract-plugin
module.exports = {"results":"AccessKeySearchResults_results__3pjRj"};